/* C8-07 — mini-carrinho como melhoria progressiva.
 *
 * Regra que este arquivo respeita, e que é a razão de ele existir assim: o
 * formulário de compra do tema é nativo e funciona sem JavaScript. Este script
 * NÃO substitui esse caminho — ele o intercepta apenas enquanto está rodando.
 * Se falhar, se não carregar, ou se o navegador não executar JS, o submit segue
 * para /cart como sempre seguiu.
 *
 * Por isso não há `preventDefault` incondicional: ele só acontece depois de a
 * requisição ter dado certo. Qualquer erro devolve o controle ao form nativo.
 */
(function () {
  'use strict';

  var painel = document.querySelector('[data-cof-minicart]');
  var fundo = document.querySelector('[data-cof-minicart-backdrop]');
  if (!painel || !fundo) return;

  var corpo = painel.querySelector('[data-cof-minicart-corpo]');
  var subtotal = painel.querySelector('[data-cof-minicart-subtotal]');
  var fechar = painel.querySelector('[data-cof-minicart-fechar]');
  var continuar = painel.querySelector('[data-cof-minicart-continuar]');
  var ultimoFoco = null;

  /* Pede ao CDN da Shopify a versão já redimensionada, preservando a query que
     a URL do `/cart.js` traz. Se a URL não for absoluta ou o `URL` falhar, o
     original volta: miniatura pesada é melhor que miniatura quebrada. */
  function comLargura(src, largura) {
    try {
      var u = new URL(src, window.location.origin);
      u.searchParams.set('width', String(largura));
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function dinheiro(centavos) {
    return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function focaveis() {
    return painel.querySelectorAll('a[href], button:not([disabled])');
  }

  function abrir() {
    /* C11-09 — quem devolve o foco tem de ser lembrado ANTES do `disabled`.
     *
     * Medido: com o foco no "Assinar agora", clicar e depois fechar com Esc
     * deixava `document.activeElement` em `BODY`, e a pessoa recomeçava a
     * tabulação no topo do site — no meio de uma compra.
     *
     * A causa não estava no fechamento, que já chamava `ultimoFoco.focus()`:
     * estava aqui. `ocupar(form, true)` DESABILITA o botão durante a
     * requisição, e elemento focado que fica `disabled` perde o foco na hora —
     * o navegador o joga em `BODY`. Quando `abrir()` rodava, duas requisições
     * depois, `document.activeElement` já era `BODY`, e era `BODY` que ficava
     * guardado como "quem abriu".
     *
     * Por isso o envio anota o foco antes de desabilitar, e aqui só se usa
     * `activeElement` quando não há anotação (o painel aberto por outro
     * caminho). */
    if (!ultimoFoco || !document.contains(ultimoFoco)) ultimoFoco = document.activeElement;
    fundo.hidden = false;
    painel.hidden = false;
    // Força reflow para a transição partir do estado fechado.
    void painel.offsetWidth;
    painel.classList.add('is-open');
    /* O foco vai para o DIÁLOGO, não para a primeira ação dele: quem usa leitor
       de tela precisa ouvir o que aconteceu antes de ouvir como descartar. A
       armadilha de foco abaixo garante que o Tab seguinte fique aqui dentro. */
    painel.focus();
    document.addEventListener('keydown', aoTeclado);
    travarFundo(true);
    marcarRolavel();
  }

  /* C11-09 — o fundo rolava atrás de um diálogo `aria-modal="true"`.
   *
   * Medido em 320×568 com o painel aberto: `window.scrollBy(0, 400)` movia a
   * página. Não havia uma linha de trava no arquivo.
   *
   * ⚠️ E a primeira medição que eu fiz disso MENTIU: li `window.scrollY` no
   * mesmo tique do `scrollBy` e recebi o valor antigo, com o painel aberto E
   * fechado. O delta zero parecia prova de que estava travado. O controle
   * negativo — medir com o painel fechado — foi o que denunciou o instrumento.
   *
   * A largura da barra de rolagem volta como `padding-right` porque
   * `overflow: hidden` a remove e o conteúdo do fundo pularia para a direita no
   * desktop, no mesmo quadro em que o painel entra. */
  var yTravado = 0;

  function travarFundo(travar) {
    var raiz = document.documentElement;
    var corpoDoc = document.body;
    if (travar) {
      /* ⚠️ `overflow: hidden` na raiz NÃO basta, e eu tentei primeiro: medido
       * com a classe aplicada e a regra vencendo em especificidade, a página
       * continuou rolando 400px. É também a técnica que notoriamente falha no
       * Safari do iPhone, onde não dá para testar aqui.
       *
       * `position: fixed` com deslocamento negativo tira o documento do fluxo
       * de rolagem de vez. O preço é ter de guardar e devolver a posição — sem
       * isso, fechar o painel joga a pessoa no topo da página. */
      yTravado = window.scrollY || raiz.scrollTop || 0;
      var barra = window.innerWidth - raiz.clientWidth;
      corpoDoc.style.position = 'fixed';
      corpoDoc.style.top = -yTravado + 'px';
      corpoDoc.style.left = '0';
      corpoDoc.style.right = '0';
      corpoDoc.style.width = '100%';
      if (barra > 0) corpoDoc.style.paddingRight = barra + 'px';
      return;
    }
    corpoDoc.style.position = '';
    corpoDoc.style.top = '';
    corpoDoc.style.left = '';
    corpoDoc.style.right = '';
    corpoDoc.style.width = '';
    corpoDoc.style.paddingRight = '';
    /* `auto` porque a raiz tem `scroll-behavior: smooth`: sem desligar, devolver
       a posição vira uma animação de volta e a página parece pular sozinha. */
    var antes = raiz.style.scrollBehavior;
    raiz.style.scrollBehavior = 'auto';
    window.scrollTo(0, yTravado);
    raiz.style.scrollBehavior = antes;
  }

  /* Só marca quando há mesmo o que rolar: esmaecer sempre apagaria a última
     linha de um painel que não rola, que é o caso comum. */
  function marcarRolavel() {
    if (!corpo) return;
    var sobra = corpo.scrollHeight - corpo.clientHeight;
    if (sobra <= 1) { corpo.removeAttribute('data-rolavel'); return; }
    var noFim = corpo.scrollTop + corpo.clientHeight >= corpo.scrollHeight - 1;
    corpo.setAttribute('data-rolavel', noFim ? 'fim' : 'sim');
  }

  /* C11-09 — o painel ENTRAVA animado e SUMIA de uma vez.
   *
   * Filmado quadro a quadro em 393px: a entrada desliza de `translateY(417px)`
   * até 0 em ~280ms, cinco quadros bonitos. O fechamento ia direto para
   * `hidden`, matando a transição de saída no primeiro quadro — o objeto some
   * do lugar em vez de ir embora, e a pessoa não vê para onde ele foi.
   *
   * A saída agora tira só a classe, deixa a transição correr e esconde depois.
   * Com `prefers-reduced-motion: reduce` a duração é `0s` pela regra do CSS, e o
   * `transitionend` não dispara — por isso a leitura da duração decide, em vez
   * de um `setTimeout` fixo que deixaria o painel visível meio segundo para quem
   * pediu para não ter movimento. */
  var duracaoDaSaida = function () {
    var d = getComputedStyle(painel).transitionDuration || '0s';
    var n = parseFloat(d) || 0;
    return d.indexOf('ms') > -1 ? n : n * 1000;
  };

  function fechaPainel() {
    painel.classList.remove('is-open');
    fundo.hidden = true;
    document.removeEventListener('keydown', aoTeclado);
    travarFundo(false);

    var ms = duracaoDaSaida();
    if (ms > 0) {
      window.setTimeout(function () {
        /* Se alguém reabriu no meio da saída, não esconder por cima. */
        if (!painel.classList.contains('is-open')) painel.hidden = true;
      }, ms);
    } else {
      painel.hidden = true;
    }

    // Devolve o foco a quem abriu: sem isso o teclado volta para o topo da página.
    if (ultimoFoco && document.contains(ultimoFoco)) ultimoFoco.focus();
  }

  function aoTeclado(evento) {
    if (evento.key === 'Escape') {
      fechaPainel();
      return;
    }
    if (evento.key !== 'Tab') return;
    // Armadilha de foco: sem ela o Tab passeia pela página atrás do painel.
    var lista = focaveis();
    if (!lista.length) return;
    var primeiro = lista[0];
    var ultimo = lista[lista.length - 1];
    if (evento.shiftKey && document.activeElement === primeiro) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primeiro.focus();
    }
  }

  /* C11-09 — dá para desfazer sem sair do painel.
   *
   * O campo "Quantas assinaturas" aceita até 99. Quem digitou 10 por engano
   * chegava a este painel, via "R$ 1.899,00" e não tinha saída nenhuma: a única
   * forma de corrigir era ir para /cart. Um painel que só relata o que aconteceu
   * é pior que um que deixa arrumar — ainda mais quando o que aconteceu foi um
   * compromisso mensal.
   *
   * `line` é 1-based na API da Shopify, e é o índice da linha e não o id da
   * variante de propósito: a mesma variante pode aparecer em duas linhas com
   * planos diferentes, e remover por id levaria as duas. */
  function remover(linha1) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: linha1, quantity: 0 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change falhou');
        return r.json();
      })
      .then(function (carrinho) {
        /* O item JÁ saiu do carrinho neste ponto — mesma situação do fluxo de
           adicionar, e por isso a mesma proteção: se qualquer coisa falhar ao
           redesenhar, a pessoa não pode ficar olhando um painel que mostra o que
           não existe mais. O pior caso vira /cart, que sempre funcionou. */
        try {
          desenha(carrinho);
          var contador = document.querySelector('[data-cof-cart-count]');
          if (contador) {
            contador.textContent = carrinho.item_count;
            if (carrinho.item_count === 0) contador.setAttribute('hidden', '');
          }
          /* Carrinho vazio não tem o que mostrar, e "Ver o carrinho" levaria a
             uma página vazia: o painel se fecha e devolve a pessoa à escolha. */
          if (carrinho.item_count === 0) { fechaPainel(); return; }
          var alvo = focaveis()[0];
          if (alvo) alvo.focus();
        } catch (erro) {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        /* C11-09 — SEM CONEXÃO, navegar leva à página de erro do navegador.
         *
         * Medido com a rede derrubada por CDP depois da carga, carrinho com duas
         * linhas: clicar em "Remover" caía direto no `location.href = '/cart'`,
         * o navegador abria `chrome-error://chromewebdata/` com
         * `ERR_INTERNET_DISCONNECTED`, o painel deixava de existir — e o item
         * continuava no carrinho.
         *
         * O caminho irmão, o de ADICIONAR, já tratava isso: fica na página, com
         * a escolha intacta e um aviso. O tratamento existia para um e não para
         * o outro, e é a mesma mensagem `data-msg-rede` que já está no HTML.
         *
         * Erro de servidor continua indo para /cart, que sempre funcionou. */
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
          var aviso = painel.querySelector('[data-cof-minicart-aviso]');
          if (aviso) {
            aviso.textContent = aviso.getAttribute('data-msg-rede') || '';
            aviso.hidden = false;
            var botao = corpo.querySelector('.cofcof-minicart__remover[disabled]');
            if (botao) { botao.disabled = false; botao.textContent = 'Remover'; }
            return;
          }
        }
        /* Falhou por outro motivo: /cart é o caminho que sempre funcionou, e a
           pessoa precisa chegar a algum lugar onde consiga corrigir. */
        window.location.href = '/cart';
      });
  }

  function stageFor(item) {
    var handle = String(item.handle || '');
    var templates = document.querySelectorAll('template[data-cof-stage-handle]');
    for (var i = 0; i < templates.length; i++) {
      if (templates[i].getAttribute('data-cof-stage-handle') === handle) return templates[i];
    }
    return null;
  }

  function desenha(carrinho) {
    corpo.innerHTML = '';

    /* C11-09 — quem decide a grade é a LISTA, não a linha.
     *
     * A rodada 9 colapsou a coluna da foto na linha que não tem imagem, para
     * matar um buraco de 64px. Nunca mediu o caso MISTO — que é o caso real
     * quando o pré-pago entra junto com a assinatura: medido em 393, a linha
     * com foto começava em x=102 e a sem foto em x=24. **78px** de divergência
     * entre irmãs, e a lista lia como duas listas.
     *
     * Se ALGUMA linha tem foto, todas mantêm a coluna e o eixo é um só. Se
     * nenhuma tem, todas colapsam e não sobra buraco. Os dois defeitos morrem
     * na mesma decisão, e ela só pode ser tomada aqui, olhando o conjunto. */
    var algumaFoto = carrinho.items.some(function (i) { return !!i.image || !!stageFor(i); });
    carrinho.items.forEach(function (item, indice) {
      var linha = document.createElement('div');
      linha.className = 'cofcof-minicart__item';

      /* C11-09 — sem foto, a coluna de 64px não fica reservada.
       *
       * Medido com o pré-pago no carrinho: `featured_image: null`, zero imagens
       * no cadastro — e a linha ficava com um buraco de 64px à esquerda, que lê
       * como imagem que não carregou. O `<span>` vazio que existia aqui
       * preenchia a célula do grid sem preencher nada.
       *
       * Cadastrar a foto é do dono; não deixar a falta dela parecer defeito é
       * daqui. */
      if (!algumaFoto) linha.classList.add('cofcof-minicart__item--sem-foto');

      var stageTemplate = stageFor(item);
      if (!item.image && !stageTemplate && algumaFoto) linha.appendChild(document.createElement('span'));

      if (stageTemplate) {
        linha.appendChild(stageTemplate.content.firstElementChild.cloneNode(true));
      } else if (item.image) {
        var img = document.createElement('img');
        /* C11-09 — 724×1086 baixados para desenhar 64×64.
         *
         * `/cart.js` devolve a URL do original. O CDN da Shopify aceita
         * `width=` e devolve a versão já redimensionada; 128 e não 64 porque a
         * tela do telefone é 2×. `srcset` fica de fora de propósito: com um
         * tamanho fixo de 64px ele só serviria para o 1×, que é o caso raro.
         *
         * A troca é feita com URL, não com string colada, porque a URL do CDN
         * já vem com query (`v=`) e concatenar `?` produziria uma URL inválida
         * que o navegador resolve como imagem quebrada. */
        img.src = comLargura(item.image, 128);
        img.width = 64;
        img.height = 64;
        img.loading = 'lazy';
        // Decorativa: o nome do produto já está em texto ao lado.
        img.alt = '';
        linha.appendChild(img);
      }

      var texto = document.createElement('div');
      var nome = document.createElement('span');
      nome.className = 'cofcof-minicart__nome';
      nome.textContent = item.product_title;
      texto.appendChild(nome);

      if (item.variant_title && item.variant_title.indexOf('Default') === -1) {
        var variante = document.createElement('div');
        variante.className = 'cofcof-minicart__variante';
        variante.textContent = item.variant_title;
        texto.appendChild(variante);
      }

      /* C11-09 — a linha dizia "2 × R$ 189,90" e nunca R$ 379,80.
       * Mesmo defeito que a caixa acima tinha e que a rodada 7 corrigiu: o que
       * a pessoa confere é quanto aquela linha custa, e o total dela não
       * aparecia em lugar nenhum — só somado com as outras, no subtotal. */
      var qtd = document.createElement('div');
      qtd.className = 'cofcof-minicart__variante';
      qtd.textContent = item.quantity > 1
        ? item.quantity + ' × ' + dinheiro(item.final_price) + ' = ' + dinheiro(item.final_line_price)
        : item.quantity + ' × ' + dinheiro(item.final_price);
      texto.appendChild(qtd);

      /* C11-09 — o painel precisa DIZER que a cobrança se repete.
       *
       * Medido depois de "Assinar agora": o texto inteiro do painel era
       * produto, variante e "1 × R$ 229,90". Zero palavras sobre recorrência,
       * periodicidade ou cancelamento — no momento exato em que a pessoa assume
       * um compromisso mensal. E o dado já vinha: `/cart.js` devolve
       * `selling_plan_allocation.selling_plan.name` ("Entrega todo mês"); este
       * renderizador simplesmente não o lia.
       *
       * O agravante que decidiu a prioridade: o PRÉ-PAGO, que não é recorrente,
       * gasta uma frase inteira dizendo "não há cobrança recorrente e não renova
       * sozinho". O produto recorrente dizia menos sobre recorrência que o não
       * recorrente. A divulgação estava invertida.
       *
       * O nome do plano vem da Shopify, não é escrito aqui. */
      var plano = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      if (plano && plano.name) {
        var rec = document.createElement('div');
        rec.className = 'cofcof-minicart__recorrencia';
        rec.textContent = 'Assinatura · ' + plano.name + ' · cancele quando quiser';
        texto.appendChild(rec);
      } else {
        /* C11-09 — a inversao da rodada 6, ao contrario.
         *
         * Medido com o pre-pago e a assinatura no mesmo carrinho: as linhas de
         * assinatura diziam "Assinatura · Entrega todo mes", e a linha do
         * pre-pago nao dizia nada. Duas naturezas de cobranca somadas num
         * subtotal so, e so uma delas declarada. A rodada 6 corrigiu a falta no
         * recorrente; a falta ficou no outro. */
        var uma = document.createElement('div');
        uma.className = 'cofcof-minicart__recorrencia';
        uma.textContent = 'Compra única · não renova sozinho';
        texto.appendChild(uma);
      }

      var tirar = document.createElement('button');
      tirar.type = 'button';
      tirar.className = 'cofcof-minicart__remover';
      tirar.textContent = 'Remover';
      /* O nome acessível diz O QUE some. Uma lista de botões "Remover" idênticos
         obriga o leitor de tela a caçar o contexto linha a linha. */
      /* ⚠️ Medido com quatro linhas no carrinho: TRES delas tinham o nome
       * acessivel identico, porque eram o mesmo produto em variantes
       * diferentes. O comentario antigo prometia que o nome dizia O QUE some,
       * e no unico estado em que isso importa - mais de uma linha do mesmo
       * produto - ele nao dizia. A variante e justamente o que distingue. */
      tirar.setAttribute('aria-label', 'Remover ' + item.product_title
        + (item.variant_title && item.variant_title.indexOf('Default') === -1 ? ', ' + item.variant_title : '')
        + ' do carrinho');
      tirar.addEventListener('click', function () {
        tirar.disabled = true;
        tirar.textContent = 'Removendo…';
        remover(indice + 1);
      });
      texto.appendChild(tirar);

      linha.appendChild(texto);
      corpo.appendChild(linha);
    });
    subtotal.textContent = dinheiro(carrinho.total_price);
    sincronizarPagamentos(carrinho);
    /* A lista acabou de mudar de tamanho: remarcar antes de a pessoa olhar. */
    marcarRolavel();
  }

  /* C12 — a faixa de meios de pagamento tem de acompanhar o carrinho.
   *
   * Com assinatura na lista, o checkout oferece SÓ cartão: meio local não
   * sustenta cobrança recorrente e a Shopify remove Pix e boleto sozinha —
   * medido em 10/09/2026 nos três cenários. O painel é redesenhado a cada
   * mudança sem recarregar a página, então uma faixa decidida só no Liquid
   * ficaria contando a história do carrinho anterior: bastava adicionar o Clube
   * a um carrinho de avulso para a tela prometer um Pix que não existiria uma
   * tela adiante. */
  function sincronizarPagamentos(carrinho) {
    var faixa = painel.querySelector('.cofcof-pagamentos');
    if (!faixa) return;
    var itens = (carrinho && carrinho.items) || [];
    var temPlano = false;
    for (var i = 0; i < itens.length; i++) {
      if (itens[i].selling_plan_allocation) { temPlano = true; break; }
    }
    var locais = faixa.querySelectorAll('[data-cof-pag]');
    for (var j = 0; j < locais.length; j++) locais[j].hidden = temPlano;
    var nota = faixa.querySelector('[data-cof-pag-nota]');
    if (nota) nota.hidden = !temPlano;
  }

  /* C11-09 — estado de envio no formulário que COBRA.
   *
   * Este handler faz duas requisições em série (`/cart/add.js` → `/cart.js`)
   * antes de qualquer mudança na tela. Sem sinal nenhum, o botão continua
   * clicável durante a espera: um toque duplo em rede lenta manda dois `add` e
   * a pessoa leva dois itens. O tema já tinha o padrão em
   * `cofcof-global.js` (`aria-busy` no formulário de coleção) e ele nunca foi
   * aplicado justamente aqui. */
  function ocupar(form, ocupado) {
    var botao = form.querySelector('[data-cofcof-buybox-submit]') || form.querySelector('button[name="add"]');
    var rotulo = form.querySelector('[data-cofcof-buybox-submit-label]');
    if (ocupado) {
      form.setAttribute('aria-busy', 'true');
      if (botao) {
        botao.disabled = true;
        if (rotulo && !botao.dataset.rotuloAntes) {
          botao.dataset.rotuloAntes = rotulo.textContent;
          rotulo.textContent = 'Adicionando…';
        }
      }
      return;
    }
    form.removeAttribute('aria-busy');
    if (botao) {
      botao.disabled = false;
      if (rotulo && botao.dataset.rotuloAntes) {
        rotulo.textContent = botao.dataset.rotuloAntes;
        delete botao.dataset.rotuloAntes;
      }
    }
  }

  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    /* Segundo envio enquanto o primeiro está no ar não vira segundo item. */
    if (form.getAttribute('aria-busy') === 'true') { evento.preventDefault(); return; }

    /* Anotado antes de `ocupar`, que desabilita o botão e faria o foco cair em
       `BODY` — ver o comentário em `abrir()`. */
    /* ⚠️ O SAFARI NÃO DÁ FOCO A UM `<button>` CLICADO.
     *
     * Medido em WebKit: `form.contains(document.activeElement)` dava falso,
     * `ultimoFoco` ficava `null`, `abrir()` guardava o `BODY` — e o Esc devolvia
     * o foco ao topo do site. No Chrome, com clique real, o mesmo caminho volta
     * para "Assinar agora". A rodada 8 refutou este sintoma **no Chrome**,
     * porque ali o instrumento usava `requestSubmit()`; em outro motor o
     * resultado é outro, e a refutação não vale para os dois.
     *
     * Quem abriu o painel foi o botão de envio deste formulário, o navegador
     * tendo lhe dado foco ou não. É ele o destino de volta. */
    var focado = document.activeElement && form.contains(document.activeElement)
      ? document.activeElement
      : null;
    ultimoFoco = focado || form.querySelector('[data-cofcof-buybox-submit]')
      || form.querySelector('button[name="add"]')
      || null;

    // Ainda NÃO cancelamos o envio: só depois de a requisição dar certo.
    var dados = new FormData(form);
    ocupar(form, true);

    fetch('/cart/add.js', {
      method: 'POST',
      body: dados,
      headers: { Accept: 'application/json' },
    })
      .then(function (resposta) {
        if (!resposta.ok) throw new Error('add falhou');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (resposta) {
        return resposta.json();
      })
      .then(function (carrinho) {
        // O item JÁ está no carrinho neste ponto. Se qualquer coisa falhar ao
        // desenhar ou abrir o painel, a pessoa não pode ficar sem resposta na
        // tela — ela levaria o produto sem saber. Por isso o bloco inteiro é
        // protegido, e o pior caso vira o comportamento de sempre: ir para
        // /cart, exatamente como o formulário nativo faria.
        try {
          desenha(carrinho);
          abrir();
          var contador = document.querySelector('[data-cof-cart-count]');
          if (contador) {
            contador.textContent = carrinho.item_count;
            // Ele nasce `hidden` com o carrinho vazio; revelar faz parte de
            // atualizar. Sem isto, o primeiro item da sessão não aparece no header.
            if (carrinho.item_count > 0) contador.removeAttribute('hidden');
          }
          ocupar(form, false);
        } catch (erro) {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        /* O `form.submit()` abaixo navega, mas se a navegação for barrada a
           pessoa não pode ficar com um botão morto na tela. */
        ocupar(form, false);

        /* C11-09 — SEM CONEXÃO, navegar é o pior que dá para fazer.
         *
         * Medido com a rede derrubada por CDP depois do carregamento: o `catch`
         * caía direto no envio nativo, o navegador começava a navegar e a página
         * ficava em branco — com o item FORA do carrinho e todas as escolhas da
         * pessoa perdidas. Ela tinha acabado de escolher quantidade e moagem.
         *
         * Offline, a escolha fica onde está e a mensagem explica. Erro de
         * servidor continua caindo no envio nativo, que sempre funcionou e foi o
         * caminho exercitado quando a Shopify respondeu 429. */
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
          var aviso = form.querySelector('[data-cofcof-buybox-unavailable]');
          var msg = aviso && aviso.getAttribute('data-msg-rede');
          if (aviso && msg) {
            aviso.textContent = msg;
            aviso.hidden = false;
            return;
          }
        }
        // A requisição falhou: manda o formulário do jeito nativo, que sempre
        // funcionou. Foi o caminho exercitado quando a Shopify respondeu 429 ao
        // navegador de teste — e o produto continuou comprável.
        form.submit();
      });

    // A partir daqui o envio nativo é cancelado porque a requisição assumiu.
    // Se ela falhar, o `catch` acima refaz o submit.
    evento.preventDefault();
  });

  if (corpo) corpo.addEventListener('scroll', marcarRolavel, { passive: true });
  window.addEventListener('resize', function () { if (!painel.hidden) marcarRolavel(); });

  if (fechar) fechar.addEventListener('click', fechaPainel);
  if (continuar) continuar.addEventListener('click', fechaPainel);
  fundo.addEventListener('click', fechaPainel);
})();
// COFCOF product presentation 2026-10-21 v1.
